import { BUILD_META } from 'src/environments/build-meta.generated';
import { environment } from 'src/environments/environment';

/** SemVer for admin UI (no SHA). */
export function appVersionLabel(): string {
  return (BUILD_META.appVersion || environment.appVersion || '1.0.0')
    .trim()
    .replace(/^v/i, '');
}

/** Full build identity for logs/support (version + sha). */
export function appBuildIdentity(): string {
  const version = appVersionLabel();
  const sha = (BUILD_META.buildTag || environment.buildTag || '').trim();
  return sha ? `${version} (${sha})` : version;
}
